import React from 'react';
import { Check } from 'lucide-react';

export const PACKAGES = [
  { id: 'initial', name: 'Initial Consultation', usd: 40 },
  { id: 'followup', name: 'Follow-up Consultation', usd: 40 },
  { id: 'complex', name: 'Complex Autoimmune / Vasculitis Second Opinion', usd: 60 },
];

export const PackagePicker = ({ value, onChange }) => (
  <div data-testid="package-picker" className="grid gap-2">
    <span className="text-sm font-semibold text-teal-900">Consultation type</span>
    {PACKAGES.map((p) => {
      const on = value === p.id;
      return (
        <button key={p.id} type="button" data-testid={`package-${p.id}`} onClick={() => onChange(p.id)}
          className={`flex items-center justify-between gap-3 text-left px-4 py-3 rounded-xl border transition-colors ${on ? 'border-teal-500 bg-teal-50' : 'border-teal-100 bg-white hover:border-teal-300'}`}>
          <span className="flex items-center gap-3 text-sm text-slate-700">
            <span className={`grid place-items-center w-5 h-5 rounded-full border ${on ? 'bg-teal-600 border-teal-600 text-white' : 'border-slate-300'}`}>{on && <Check size={12} />}</span>
            {p.name}
          </span>
          <span className="font-semibold text-teal-900 whitespace-nowrap">USD {p.usd}</span>
        </button>
      );
    })}
  </div>
);
